import styled from 'styled-components';

import DropdownSearch from 'shared/components/DropdownSearch';
import { device, colors, fonts } from 'shared/defaultTheme';
import { Modal } from 'shared/components/modal/Modals';

export const UserWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
`;

export const TopDropdownSearch = styled(DropdownSearch)`
  .select-search .select-search__options {
    list-style-type: none;
    padding: 0;
    height: auto;
    max-height: 400px;
    overflow-y: scroll;
  }

  @media ${device.sm} {
    .select-search {
      flex: 0 0 79%;
    }
    width: 111%;
  }
`;

export const HelpFormModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .top-help-modal-container {
    .top-help-title {
      font-size: 24px;
      color: ${colors.blueLefebvre};
      font-family: ${fonts.medium}, Arial, sans-serif;
    }
    .top-info-box {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 0.3rem;
      box-shadow: 0 0 4px rgb(0 0 0 / 20%);
      width: 25%;
      display: flex;
      justify-content: center;
      .top-info-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .lf-icon {
          font-size: 50px;
          color: ${colors.blueLefebvre};
        }
        .help-sub-title {
          font-size: 24px;
          color: ${colors.blueLefebvre};
          font-family: ${fonts.medium}, Lato, Arial, sans-serif;
          text-transform: none;
        }
        .help-text-info {
          font-size: 16px;
          color: ${colors.ecru};
          font-family: ${fonts.medium}, Lato, Arial, sans-serif;
          margin-top: 0;
          margin-bottom: 1rem;
          text-align: center;
        }
        .help-contact-info {
          font-size: 17px;
          color: ${colors.blueLefebvre};
          font-family: ${fonts.medium}, Lato, Arial, sans-serif;
        }
        .help-time-info {
          font-size: 14px;
          color: #4a4a4a;
          font-family: ${fonts.medium}, Lato, Arial, sans-serif;
        }
        .btn-send-mail {
          background-color: ${colors.white};
          border: 1px solid ${colors.blueLefebvre};
          border-radius: 0;
          font-size: 14px;
          color: ${colors.blueLefebvre};
          font-family: ${fonts.black}, Lato, Arial, sans-serif;
          text-transform: uppercase;
          box-shadow: none;
          padding: 7px 30px 6px;
          &:hover {
            background-color: ${colors.blueLefebvre};
            color: ${colors.white};
          }
        }
        .btn-chat-active {
          width: auto;
          height: 36px;
        }
      }
    }
    .center-help-container {
      background-color: ${colors.blueLefebvre};
      .top-info-container {
        .title-center-help {
          border-bottom: 1px solid ${colors.white};
          width: 93%;
          text-align: center;
          color: ${colors.white};
        }
        .lf-icon {
          color: ${colors.white};
        }
        .center-help-info-container {
          display: grid;
          grid-template-columns: 50% 50%;
          .center-help-info-box {
            height: 82px;
            width: 113px;
            border: 1px solid ${colors.lifeboatBlue};
            margin: 5px 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            cursor: pointer;
            &:hover {
              background: ${colors.ecru};
            }
            .center-help-lf-icon {
              font-size: 25px;
              display: block;
              color: ${colors.white};
            }
            .center-help-text {
              font-size: 10px;
              color: ${colors.white};
              font-family: ${fonts.default}, Lato, Arial, sans-serif;
              text-transform: uppercase;
            }
          }
        }
      }
    }
    .btn-go-center-help {
      background-color: ${colors.blueLefebvre};
      border: 1px solid ${colors.blueLefebvre};
      border-radius: 0;
      font-size: 14px;
      color: ${colors.white};
      font-family: ${fonts.black}, Lato, Arial, sans-serif;
      text-transform: uppercase;
      box-shadow: none;
      padding: 7px 30px 6px;
      cursor: pointer;
      &:hover {
        background-color: ${colors.ecru};
      }
    }
  }
`;

export const Logo = styled.div(({ imageSrc }) => ({
  background: `url('${imageSrc}')`,
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  width: '100px',
  height: '49px',
}));
